import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  HostListener
} from '@angular/core';

import { DataService } from 'src/app/services/data.service';

import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {

  @Input() isMenu;
  @Input() modal;
  @Output() activateMenu =  new EventEmitter();

  constructor(public db:DataService,public modalCtrl:ModalController) { }

  ngOnInit() {
    // this.db.modal_popup = false;
    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');

  }

  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modalCtrl.dismiss();
  }

  goto(item,current_title){
    let value :any = {};
    value.item = item
    value.current_title = current_title
    this.db.report.next(value) 
  }
  close(){
    this.modalCtrl.dismiss();
  }


}
